import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SmtpConfig } from '../../models/smtp-config.model';
import { MatIconModule } from '@angular/material/icon';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SettingsService } from '../../services/settings.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';
import { SettingsSmtpTableComponent } from '../settings-smtp-table/settings-smtp-table.component';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-settings-smtp-list',
    standalone: true,
    imports: [
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonToggleModule,
        MatButtonModule,
        MatCardModule,
        CommonModule
        //SettingsSmtpTableComponent
    ],
    templateUrl: './settings-smtp-list.component.html',
    styleUrl: './settings-smtp-list.component.css',
    providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})
export class SettingsSmtpListComponent implements OnInit {

  public filter: FormControl = new FormControl('');


  public AccountTypes = [
    {
      value: 'REPORT',
      name:'RAPORT'
    },
    {
      value: 'ALERT',
      name: 'ALERT'
  }];

  public AuthState = [
      {
        value: 0,
        name:'NIE'
      },
      {
        value: 1,
        name: 'TAK'
  }];
  
  public TLSState = [
        {
          value: 0,
          name:'Wyłączony'
        },
        {
          value: 1,
          name: 'Włączony'
  }];
  
  public selectedTLSState: number = 0; //FormControl = new FormControl(0, [Validators.required]);
  public selectedAuthState: number = 0; //FormControl = 0;//new FormControl(0, [Validators.required]);
  public selectedAuthStateForm: FormControl = new FormControl(0, [Validators.required]);
  public selectedType: string = "";//new FormControl('', [Validators.required]);
  public selectedTypeForm: FormControl = new FormControl('', [Validators.required]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public editForm: FormGroup = new FormGroup({});
  public accounts: SmtpConfig[] = [];

  public currentAccount?: SmtpConfig;
  public dataSource = new MatTableDataSource<any>(this.accounts);

  public displayedColumns: string[] = [
    'host', 
    'port', 
    'start_tls_enable', 
    'auth', 
    'username', 
    'password', 
    'account_type', 
    'action'
  ];

  constructor(
    private modalService: NgbModal,
    private settingsService: SettingsService,
    public router: Router,
  ) {

  }

  ngOnInit(): void {
      this.fetchSmtpConfig();
  }

  fetchSmtpConfig() {
    this.settingsService.fetchSmtp()
    .subscribe({
      next: (response: any) => {

        console.log("fetchSmtpConfig", response);

        this.accounts = response.settings.map( (el: SmtpConfig) => {
          return el;
        });

        this.dataSource =  new MatTableDataSource<any>(this.accounts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      },
      error: (error) => {
        console.log("fetchSmtpConfig error", error)
        if(error.status === 401) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  onSumbitSmtp() {

    const accountSettings = new SmtpConfig(
      this.editForm.value.id,
      this.editForm.value.host,
      this.editForm.value.port,
      this.editForm.value.start_tls_enable,
      this.selectedAuthStateForm.value,
      this.editForm.value.username,
      this.editForm.value.password,
      this.selectedTypeForm.value
    );

    if(accountSettings.id) {
      this.settingsService.updateSmtp(accountSettings)
      .subscribe({
        next: (response: any) => {
          console.log("subscribe updateSmtp", response);
          this.fetchSmtpConfig();
        },
        error: (error) => {
          alert("Wrong data: " + error.error.message);
        }
      })
    }

  }

  deleteElement(element: SmtpConfig) {
    console.log("deleteElement");

  }

  public openModal(modal: any, account: SmtpConfig) {

    this.currentAccount =  account
    console.log("openModal", this.currentAccount)

    if(account.id) {
      this.initForm(account)
    } else {
      this.initForm(this.createSMTP())
    }

    this.modalService.open(modal);
  }

  createSMTP() {
    let newAccount = new SmtpConfig(0, "", 0,0,0,"","","");
    return newAccount;
  }

  initForm(element: SmtpConfig) {
    this.editForm = new FormGroup({
      id: new FormControl(element.id, [Validators.required]),
      host: new FormControl(element.host, [Validators.required]),
      port: new FormControl(element.port, [Validators.required]),
      start_tls_enable: new FormControl(element.start_tls_enable, [Validators.required]),
      auth: new FormControl(element.auth, [Validators.required]),
      username: new FormControl(element.username, [Validators.required]),
      password: new FormControl(element.password, [Validators.required]),
      type: new FormControl(element.type, [Validators.required]),
    })

    if(element.type !== undefined) {
      this.selectedType = element?.type;

      this.selectedTypeForm = new FormControl(element.type, [Validators.required]);

    }

    this.selectedAuthStateForm = new FormControl(element.auth, [Validators.required]);
  }

  doFilter(event: Event) {
    //let value = filterValue.target.value
    const filterValue = (event.target as HTMLInputElement).value;

    console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }  


  toggledTLS() {
    this.editForm.value.start_tls_enable = this.selectedTLSState 
    console.log("toggled", this.editForm.value.type, this.selectedTLSState )
  }

  toggledAuth() {
    this.editForm.value.auth = this.selectedAuthState 
    console.log("toggled", this.editForm.value.type, this.selectedAuthState )
  }


  toggledAccountType() {
    this.editForm.value.type = this.selectedType 
  }

}
